import type { TreeGridChartOption } from './treeGridSettings.types';

export const DEFAULT_TREE_GRID_CHART_OPTION: TreeGridChartOption = {
  sortType: 'DESC',
  isShowHeader: false,
  columns: [],
  sortColumn: '',
  groupByColumn: 'none',
  groupChild: {
    sortColumn: '',
    sortType: 'DESC',
  },
  tree: {
    parent: {
      id: '',
      sortColumn: '',
      sortType: 'DESC',
    },
    child: {
      id: '',
      sortColumn: '',
      sortType: 'DESC',
    },
  },
  isTreeMode: true,
  rowColors: [],
  rawColumns: undefined,
  referenceInfo: undefined,
  limit: 50,
  displayColumns: [],
  columnsByChartIndex: [],
  columnOrder: [],
  columnVisibility: {},
  columnSize: undefined,
  useSecondButton: false,
  tokenFilter: {
    use: true,
  },
  queryStatTimezone: {
    mode: 'account',
    timezone: undefined,
  },
};
